import { useQuery, UseQueryResult } from "@tanstack/react-query";
import UserNotificationTypeResponse from "../../../models/API/responseModels/userNotificationTypeResponse.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

function useUserNotificationTypeValues(): UseQueryResult<UserNotificationTypeResponse> {
  const { authState } = useOktaAuth();
  return useQuery({
    queryKey: ["userNotificationTypeValues"],
    queryFn: () =>
      axiosInstance
        .get("v1/user-notification-type-settings", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data),
    enabled: !!authState?.accessToken?.accessToken,
  });
}

export default useUserNotificationTypeValues;
